import React, { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'app/shared/context/Auth';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { ExpressCheckoutContextProvider } from 'app/fan/context/ExpressCheckout';
import { StripeElementsProvider } from 'app/fan/context/StripeElementsProvider';
import { GuestShareLinkModal } from 'app/fan/components/pages/Event/components';

import { BuyFlowLoggedInPostPurchaseContainer } from './BuyFlowLoggedInPostPurchaseContainer';

export * from './BuyFlowLoggedInPostPurchaseContainer';

export const BuyFlowLoggedInPostPurchaseEventPage = () => {
  const { event, eventAttendee } = useEventPageContext();
  const { user: loggedInUser } = useContext(AuthContext);

  const [showShareLinkModal, setShowShareLinkModal] = useState(false);

  useEffect(() => {
    if (event) {
      setTimeout(() => {
        setShowShareLinkModal(true);
      }, 3000);
    }
  }, [event]);

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect these to be present
  if (!event || !eventAttendee || !loggedInUser) {
    return null;
  }

  return (
    <StripeElementsProvider eventId={event.id}>
      <ExpressCheckoutContextProvider
        event={event}
        eventAttendee={eventAttendee}
      >
        <BuyFlowLoggedInPostPurchaseContainer eventAttendee={eventAttendee} />
      </ExpressCheckoutContextProvider>

      <GuestShareLinkModal
        isOpen={showShareLinkModal}
        setIsOpen={setShowShareLinkModal}
        event={event}
        ticketPurchaserName={loggedInUser.firstName}
        ticketPurchaserEventAttendeeId={eventAttendee.id}
      />
    </StripeElementsProvider>
  );
};
